import styled from '@emotion/styled';

const neutral500 = '#a7a7a7';

const Hr = styled.div`
  background-color: ${neutral500};
  height: 1px;
  width: 100%;
`;

export { Hr };
